import React, { useState } from "react";
import { Button, Input, Image, message } from "antd";

import img from "../../assets/images/user.png";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { useChangePassword } from "../../api/auth";
import WithAuth from "../../hoc/WithAuth";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

function ChangePassword() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isFirstLogin = searchParams.get("isFirstLogin");
  const { user, getUserByTolken } = useAuth() as AuthContextValue;
  // const roles = 'WEB_SHEGAFRE_ADMIN' | 'WEB_AGRO_DEALER_OPERATION' | 'MOB_AGRO_DEALER_STORE' | 'WEB_BANK_OPERATION' | 'INSURANCE_ADMIN' | 'INSURANCE_USER' | 'INSURANCE_USER' | 'WEB_OFF_TAKER_OPERATION' | 'WEB_SHEGAFRE_OPERATION' | 'WEB_INSURANCE_ADMIN' | 'WEB_BANK_ADMIN' | 'WEB_AGRO_DEALER_ADMIN' |
  //     'WEB_SHOP_ADMIN' | 'MOB_VALUE_CHAIN_EXECUTES' | 'MOB_WAREHOUSE_PERSON' | 'MOB_SELLS_PERSON' | 'MOB_AGRONOMY_PERSON'
  const [password, setPassword] = useState<string | undefined>();
  const [confirmPassword, setConfirmPassword] = useState<string | undefined>();
  const { mutateAsync: changePassword, error, data } = useChangePassword();

  const onSubmit = async () => {
    try {
      if (
        user &&
        password &&
        password === confirmPassword &&
        password?.length >= 6
      ) {
        const result = await changePassword(password);

        if (result && result.data.status === 1) {
          message.success("Password changed successfully.");
          getUserByTolken();

          if (user.roleName === "WEB_SHEGAFRE_ADMIN") {
            navigate("/admin");
          } else if (
            (user.roleName === "ROLE_MFI_ADMIN" ||
              user.roleName === "ROLE_OFF_TAKER_ADMIN" ||
              user.roleName === "INSURANCE_ADMIN" ||
              user.roleName === "WEB_INSURANCE_ADMIN" ||
              user.roleName === "WEB_BANK_ADMIN" ||
              user.roleName === "WEB_AGRO_DEALER_ADMIN") &&
            isFirstLogin === "1"
          ) {
            navigate("/documents");
          } else if (user.roleName === "ROLE_OFF_TAKER_ADMIN") {
            navigate("/off-taker");
          } else if (user.roleName === "BANK_ADMIN") {
            navigate("/bank");
          } else if (user.roleName === "INSURANCE_ADMIN") {
            navigate("/insurance");
          } else if (user.roleName === "ROLE_MPC_ADMIN") {
            navigate("/ad-dashboard");
          } else if (user.roleName === "ROLE_MPC_OPERATION") {
            navigate("/redemption");
          } else if (user.roleName === "ROLE_KFT_SP_ADMIN") {
            navigate("/admin");
          } else if (
            user.roleName === "ROLE_MFI_ADMIN" ||
            user.roleName === "ROLE_MFI_OPERATION"
          ) {
            navigate("/mfi");
          } else if (user.roleName === "ROLE_SUPER_ADMIN") {
            navigate("/sp-admin");
          }
        } else {
          message.error("Operation failed.");
        }
      }
    } catch (err: any) {
      message.error("Operation failed");
    }
  };

  return (
    <div
      style={{
        width: "50%",
        alignSelf: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 450,
        fontFamily: "Poppins",
        padding: 20,
        borderRadius: 8.5,
        marginTop: 25,
        paddingLeft: 50,
        paddingRight: 50,
        paddingTop: 22,
        backgroundColor: "white",
      }}
    >
      {user && (
        <div style={{ width: "40%", alignSelf: "center" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              gap: 12,
            }}
          >
            {/* {user.data.avatar_url && <Image preview={false} src={user.data.avatar_url} style={{ width: 100, height: 100, borderRadius: 100 }} />} */}
            <Image
              preview={false}
              src={img}
              style={{ width: 100, height: 100, borderRadius: 100 }}
            />
            {user.fullName && <div>{user.fullName}</div>}

            <Input.Password
              placeholder="Insert password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ marginTop: 20 }}
            />
            <Input.Password
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <div style={{ display: "flex", gap: 30, marginTop: 20 }}>
              <Button type="primary" onClick={onSubmit}>
                Change
              </Button>
              <Button
                onClick={() => {
                  setPassword("");
                  setConfirmPassword("");
                }}
              >
                Clear
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WithAuth(ChangePassword);
